const sonicImage = (url,width) => {
  if (!url || !width || typeof url !== "string" || url.indexOf('http') !== 0) {
    return '';
  }
  if (url.indexOf('?') > 0) {
    url = url.split('?')[0];
  }
  return `${url}?f=jpg&p=true&w=${width}&q=75`;
};

export default sonicImage;


// WEBPACK FOOTER //
// ./src/misc/sonic-image/index.js